export const USER_STATE = {
    ACTIVE: 1,
    INACTIVE: -1
};

export const USER_STATE_ARRAY = [
    { name: "Active", state: USER_STATE.ACTIVE },
    { name: "Inactive", state: USER_STATE.INACTIVE },
];

export const USER_ROLE = {
    ADMIN: 'IntenantAdmin',
    USER: 'IntenantUser',
};

export const USER_MODAL_TYPE = {
    CREATE: 'create',
    EDIT: 'edit',
}

export const ACCESS_CREDENTIAL_PROVIDER = {
    HID: 'HID',
};

export const ACCESS_CREDENTIAL_MODE = {
    MOBILE_APP: 'MOBILE_APP',
    WALLET: 'WALLET',
};

export const HID_WALLET_PASS_STATUS = {
    ISSUANCE_CREATED: 'ISSUANCE_CREATED',
    PROVISIONING: 'PROVISIONING',
    ACTIVE: 'ACTIVE',
    SUSPENDING: 'SUSPENDING',
    REMOVED: 'REMOVED',
    SUSPENDED: 'SUSPENDED',
    RESUMING: 'RESUMING',
    REVOKING: 'REVOKING',
    REVOKED: 'REVOKED',
    FAILED: 'FAILED',
};

export const DEFAULT_ACCESS_CREDENTIAL_POLICY = {
    provider: ACCESS_CREDENTIAL_PROVIDER.HID,
    mode: ACCESS_CREDENTIAL_MODE.MOBILE_APP,
};

export const CSV_EXPORT_FIELDS = ['firstName', 'lastName', 'email', 'countryDialingCode', 'contactNumber', 'licensePlate', 'tenant', 'building', 'status', "credentialId", "createdDate"];

export const CSV_ERROR_DOWNLOAD_FIELDS = ['firstName', 'lastName', 'email', 'countryDialingCode', 'contactNumber', 'licensePlate', 'tenant', 'building',  'validationMessage'];

export const ADMIN_MODAL_TYPE = {
    ASSIGN:'Assign Admin',
    Unassign:'Unassign Admin',
}
